<template>
  <div class="video" ref="video">
    <header
      class="video-title"
      :class="{'video-fixed': isFixed &&!perviewType }"
      ref="pronbit">
      <div>共{{list.length}}个知识点</div>
      <div v-if="perviewType" v-show="!isPad">
        <span>（选择知识点视频发送至学生）</span>
        <el-button
          type="primary"
          icon="el-icon-plus"
          @click="layoutPreview"
        >布置预习内容</el-button>
      </div>
      <div v-else>
        <el-checkbox
          :indeterminate="isIndeterminate"
          v-model="labelType"
          @change="handleCheckAllChange"
          style="zoom:130%;"
          >全选</el-checkbox>
          <span class="video-title__text"></span>
        <span>已选择{{checkedList.length}}个知识点</span>
        <el-button
          class="video-title__cancel"
          @click="cancelPreview"
        >取消</el-button>
        <el-tooltip
          class="item"
          effect="dark"
          content="请至少勾选一项知识点"
          :disabled="checkedList.length > 0"
          placement="top"
        >
          <el-button
              type="primary"
              @click="release"
              :class="{'video-disable': checkedList.length < 1}"
            > 下一步 完善预习内容</el-button>
        </el-tooltip>
      </div>
    </header>
    <div class="video-count" >
        <div
          class="video-count__list"
          :class="{'video-count__border': !item.active}"
          v-for="(item, index) in list" :key="index"
        >
        <!-- 是否选中 -->
          <img
            v-if="pitchOn && item.active"
            class="video-count__list__checkbox"
            @click.stop="switchOn(1, item)"
            src="../../images/CheckBox-empty.png" alt="">
            <img
            v-if="!item.active && pitchOn"
            class="video-count__list__checkbox"
            @click.stop="switchOn(2, item)"
            src="../../images/pitch-on.png" alt="">
          <!-- 主体部分 -->
          <div class="video-count__list__image">
            <img v-if="!perviewType" src="../../images/video.png" alt="">
            <img v-else src="../../images/video.png" @click="openVideo(item)" alt="">
            <img
              v-if="perviewType"
              src="../../images/aplay.png"
              @click="openVideo(item)" id="aplay">
          </div>
          <p class="video-count__list__text">
            {{item.knowledge_name}}
          </p>
          <!-- <span>学习人数：1000</span> -->
        </div>
        <div v-if="list.length < 1" class="empty">
          <img src="../../images/emptyType.png" alt="">
        </div>
    </div>
    <!-- 发布弹框 -->
    <release-dialog
      :dialogVisible.sync='dialogVisible'
      :checkedList="checkedList"
      :course="course"
      @removeList="removeList"
      @onSuccess="onSuccess"
      :releaseType.sync='releaseType'
    />
    <!-- 发布成功弹框 -->
    <success-dialog
      :releaseType='releaseType'
      @getback='getback'
      v-bind.sync="$attrs"
     />
     <!-- 视频弹框 -->
     <lo-dialog
      :visible.sync="visibleLo"
      v-if="visibleLo"
      :code="code"
      :subject-id="subjectId"
      :data="list" />
  </div>
</template>

<script>
/* eslint-disable */
import ReleaseDialog from './release-dialog.vue'
import { getInfoByChapterAndLesson } from '@/api/pt'
import  SuccessDialog from './success-dialog.vue';
import LoDialog from './lo-dialog.vue'
import { getSign } from '@/utils';

export default {
  name: 'VideoLectures',
  components: {
    ReleaseDialog,
    SuccessDialog,
    LoDialog,
  },
  props: {
    course: {
      type: Object,
      default: () => ({}),
    }
  },
  data() {
    return {
      isPad: this.$route.query.spad,
      perviewType: true,
      releaseType: false, // 发布成功后的切换
      isFixed: false, // 固定定位
      pitchOn: false, // 选中
      dialogVisible: false, // 发布弹框
      isIndeterminate: false,
      checkedList: [], // 选中列表
      list: [], // 所有列表
      code: '',
      visibleLo: false,
      subjectId: '',
      labelType: false,
    };
  },
  mounted() {
    window.addEventListener('scroll',this.handleScrollx,true)
    // this.getInfo()
  },
  watch: {
    'course.lessonId': function(val) {
      this.cancelPreview()
      this.getInfo()
    },
    'course.chapterId': function(val) {
      this.cancelPreview()
      this.getInfo()
    },
  },
  methods: {
    getInfo() {
      console.log('this.course-----------', this.course);
      const param = {
        chapter_id: this.course.chapterId,
        lesson_id: this.course.lessonId,
      };
      param.sign = getSign(param);
      getInfoByChapterAndLesson(param).then(({data}) => {
        this.list = data
        // this.$set(this.list, active, 'false')
        this.list.forEach(item => {
          item.active = true;
        })
      })
    },
    openVideo(value) {
      this.visibleLo = true;
      this.subjectId = this.course.subjectId;
      this.code = value.knowledge_code;
    },
    removeList(kitem) {
      this.checkedList = this.checkedList.filter(item => item.knowledge_code !== kitem.knowledge_code)
      this.list.forEach(item => {
        if (item.knowledge_code === kitem.knowledge_code) {
          item.active = true;
        };
      })
    },
    onSuccess() {
      this.releaseType = true;
    },
    getback() { // 发布成功后的返回
      this.releaseType = false;
      this.checkedList = [];
      this.cancelPreview();
    },
    layoutPreview() { // 点击布置
      this.perviewType = false;
      this.pitchOn = true;
    },
    handleScrollx() { // 吸顶
      if(this.$refs.pronbit) {
        if (this.$refs.pronbit.getBoundingClientRect().top < 0) this.isFixed = true;
      }
      if (this.$refs.video) {
        if (this.$refs.video.getBoundingClientRect().top >  0) this.isFixed = false;
      }
	  },
    cancelPreview() { // 取消布置
      this.perviewType = true;
      this.pitchOn = false;
      this.list.forEach(item => item.active = true)
      this.checkedList = []
      this.labelType = false
    },
    switchOn(type, item) { // 切换选中状态
      if (type === 1) item.active = false;
      if (type === 2) item.active = true;
      this.checkedList = this.list.filter(item => !item.active)
      if (this.checkedList.length < this.list.length) {
        this.isIndeterminate = true;
        this.labelType = false;
      } else {
        this.isIndeterminate = false;
        this.labelType = true;
      }
    },
    release() { // 发布
    if (this.checkedList.length > 0) this.dialogVisible = true;
      // this.releaseType = true;
    },
    handleCheckAllChange(val) { // 全选
      this.isIndeterminate = false;
      if (this.checkedList.length < this.list.length) {
        this.list.forEach(item => item.active = false)
        console.log('ll');
        this.labelType = true;
      } else {
        this.list.forEach(item => item.active = true)
        this.labelType = false;
      };
      this.checkedList = this.list.filter(item => !item.active)
    },
    handleCheckedCitiesChange(value) {
      const checkedCount = value.length;
    },
  },
  destroyed() {
    window.removeEventListener('scroll', this.handleScrollx, true);
  },
};
</script>

<style lang="scss" scoped>
.empty {
  width: 100%;
  display: flex;
  justify-content: center;
}
  .video {
    position: relative;
    font-size: 14px;
    // width: 850px;
    background-color: #fff;
    &-disable {
      background-color: #BFD3E7;
      border: 1px solid #BFD3E7;
    }
    .handout {
      display: inline-block;
      width: 100%;
      height: 135px;
      overflow: hidden;
      margin: 0;
      img {
        width: 100%;
      }
    }
    &-fixed {
      position: fixed;
      background-color: #fff;
      width: 80%;
      top: 0;
      z-index: 4444;
    }
    &-title {
      box-sizing: border-box;
      display: flex;
      // width: 80%;
      min-height: 60px;
      padding:0 20px;
      justify-content: space-between;
      align-items: center;
      &__text {
        border-left: 1px solid #979797;
        margin: 0 12px;
      }
      &__cancel {
        width: 120px;
        height: 40px;
        font-weight: 500;
        color: #1989FA;
        margin-left: 28px;
        background: #FFFFFF;
        border-radius: 4px;
        border: 1px solid #A3D0FD;
      }
      & /deep/ .el-checkbox__label {
        zoom: 82%;
        color: #000000;
      }
    }
    &-count {
      display: flex;
      justify-content: flex-start;
      flex-wrap: wrap;
      &__border {
        border: 3px solid #24A1FF !important;
        .calc {
          width: calc(100% + 1px);
        }
      }
      &__list {
        box-sizing: border-box;
        position: relative;
        width: 2.40rem;
        min-height: 2.05rem;
        background: #FFFFFF;
        box-shadow: 2px 2px 3px 0px rgba(226, 232, 241, 0.56);
        border-radius: 6px;
        border: 1px solid #EBEEF5;
        margin: 0.18rem;
        &__text {
          overflow: hidden;
          text-overflow: ellipsis;
          display: -webkit-box;
          -webkit-line-clamp: 2;
          overflow:hidden;
          /*! autoprefixer: off */
          -webkit-box-orient: vertical;
        }
        &__image {
          position: relative;
          width: calc(100% + 1px);
          #aplay {
            position: absolute;
            left: 50%;
            top: 50%;
            transform: translate(-50%,-50%);
          }
        }
        &__checkbox {
          position: absolute;
          top: -3px;
          right: -5px;
          z-index: 222;
          & /deep/ .el-checkbox__inner {
            width: 36px;
            height: 36px;
          }
        }
        p {
          margin: 11px 17px 7px 18px;
          font-size: 15px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #000000;
          line-height: 23px;
        }
        span {
          margin-left: 18px;
          font-size: 12px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #606266;
          line-height: 24px;
        }
      }
    }
  }
    .empty {
      img {
        // position: relative;
        // left: 100%;
        // // transform: translateX(-50%);
        // margin-top: 30px;
      }
    }
@media screen and (max-width:1200px) {
  .video-title {
    display: block;
  }
}
</style>
